<template>
  <div>
    <v-select
      :value="value.pageNo"
      :items="items"
      @input="$emit('input', $event)"
    >
      <template slot="append-outer">
        <span class="total pt-2">/ {{ value.count }}件</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'PageSelect',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    pageSize() {
      return this.value.pageSize
    },
    pageTotal() {
      return Math.ceil(this.value.count / this.pageSize)
    },
    items() {
      if (this.pageTotal === 0) {
        return [{ text: '0件', value: 1 }]
      }
      const pages = []
      for (let i = 1; i <= this.pageTotal; i++) {
        const start = (i - 1) * this.pageSize + 1
        const end = Math.min(i * this.pageSize, this.value.count)
        pages.push({ text: `${start}-${end}件`, value: i })
      }
      return pages
    },
  },
}
</script>

<style scoped lang="scss">
.total {
  white-space: nowrap;
}
</style>
